<script lang="ts" setup>
// #兩張圖片，左右排列，左寬右窄
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_lft)
  const img2: Ref<Image> = ref(props.data.image_rgt)
  imgData1.value = img1.value
  imgData2.value = img2.value
}
</script>

<template>
  <div class="area">
    <figure class="area__left">
      <Nimg :src="imgData1?.link" :title="imgData1?.title" :alt="imgData1?.alt" format="webp" />
    </figure>
    <figure class="area__right">
      <Nimg :src="imgData2?.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  display: flex;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  img {
    display: block;
    width: 100%;
  }

  &__left {
    width: 61%;
  }

  &__right {
    width: 39%;
    padding-left: toRem(22);
  }
}
</style>
